import type { ClientPackageChapterDto } from '../api/generated/client';
import { ClientPackageChapterName } from '../enums';
import { DEFAULT_TIME_RANGE } from './constants';

export const CHART_EXPORTER_CHAPTER_NAMES = [
    ClientPackageChapterName.PROJECTION,
    ClientPackageChapterName.EVENTS_0,
    ClientPackageChapterName.CASHFLOW,
    ClientPackageChapterName.CASHFLOW2,
    ClientPackageChapterName.FAMILY_TREE,
    ClientPackageChapterName.LIQUIDITY,
] as const;

export type ChartExporterChapterName = (typeof CHART_EXPORTER_CHAPTER_NAMES)[number];

const chartExporterChapterNameSet = new Set<string>(CHART_EXPORTER_CHAPTER_NAMES);

export function isChartExporterChapterName(chapterName: string): chapterName is ChartExporterChapterName {
    return chartExporterChapterNameSet.has(chapterName);
}

/**
 * DOM keys we must wait for before running html-to-image, aligned with {@link ChapterExporter} mount rules.
 */
export function getRequiredChartExporterDomChapterNames(chapters: ClientPackageChapterDto[] | undefined, projectionYears: number): string[] {
    const selectedNames = new Set<string>(
        (chapters ?? []).filter((c) => c.selected && chartExporterChapterNameSet.has(c.chapterName as string)).map((c) => c.chapterName as string),
    );

    const required = [...selectedNames];
    const cashflow2 = ClientPackageChapterName.CASHFLOW2 as string;
    const needsSecondCashflowPage = selectedNames.has(ClientPackageChapterName.CASHFLOW as string) && projectionYears > DEFAULT_TIME_RANGE;

    if (needsSecondCashflowPage && !selectedNames.has(cashflow2)) {
        required.push(cashflow2);
    }

    if (!needsSecondCashflowPage) {
        const idx = required.indexOf(cashflow2);
        if (idx >= 0) required.splice(idx, 1);
    }

    return required;
}
